/**
 * @desc 更新计费类型为重量段的报价
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: string,
  params: API.tms.logisticsQuotationTob.importLogisticsQuotationWeight.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationTob/importLogisticsQuotationWeight`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
